import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import {
  activitySearch,
  selectTypeFilter,
  setFilterType
} from '../../../../../../../../../redux/modules/activityLog';

const ActivityLogFilterButton = ({
  insuredId,
  recordId,
  title = 'Activity Filter Button',
  type = 'all_activity',
  dataAnalyticsId = undefined
}) => {
  const dispatch = useDispatch();
  const currentButtonFilter = useSelector(selectTypeFilter);

  const handleTypeFilterClick = () => {
    switch (type) {
      case 'all_activity':
        dispatch(activitySearch.getPage(1));
        dispatch(setFilterType('all_activity', insuredId));
        break;
      case 'activity':
        dispatch(activitySearch.getPage(1));
        dispatch(setFilterType('activity', insuredId));
        break;
      case 'comment':
        dispatch(activitySearch.getPage(1));
        dispatch(setFilterType('comment', insuredId));
        break;
      default:
        break;
    }
  };

  return (
    <Box
      _focus={{ outline: 'none' }}
      as="button"
      borderBottom={currentButtonFilter === type ? '2px solid' : ''}
      borderColor={currentButtonFilter === type ? 'primaryScale.600' : ''}
      data-analytics-id={dataAnalyticsId}
      h={8}
      textStyle={currentButtonFilter === type ? 'bodyLg600' : 'bodyLg'}
      onClick={() => handleTypeFilterClick()}
    >
      {title}
    </Box>
  );
};

ActivityLogFilterButton.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['all_activity', 'activity', 'action', 'comment']).isRequired,
  dataAnalyticsId: PropTypes.string
};

export default ActivityLogFilterButton;
